import { render, staticRenderFns } from "./SyncAlert.vue?vue&type=template&id=6f6776bf&"
import script from "./SyncAlert.vue?vue&type=script&lang=js&"
export * from "./SyncAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports